<template>
  <SimonModal
    :is-visible="showModal"
    @hide="showModal = false"
    custom-modal-class="tariffModal"
    id="app-tariff-option-revoke-modal"
    size="large"
    close-button-color="light"
    show-footer-buttons
    :btn-right-title="getSlotText('btnBookOptionModal', 'Kündigung widerrufen')"
    disabled-btn-right
    @btnLeft="showModal = false"
    sticky-header
  >
    <template v-slot:modalTitle>
      <div class="box-head-left">
        <div class="box-head-title">
          <h4>{{ option.name }}</h4></div>
        <div class="box-head-data"><h4>{{ formattedIncentive }}</h4></div>
      </div>
      <div class="box-head-right">
        <div class="box-head-price">
          <span>{{ formattedPrice }}</span>
        </div>
        <div class="box-head-price-data">
          <span class="price--cur">&euro;</span>
          <span class="price--period">
          <slot name="txtPeriodAbo" v-if="option.automaticExtension">monatlich</slot>
          <slot name="txtPeriodOnetime" v-else>einmal</slot>
        </span>
        </div>
      </div>
    </template>
    <div class="option-modal--body">
      <div class="info">
        <slot name="txtNotBookableModal"></slot>
      </div>
    </div>
    <div v-if="gotBackendError" v-html="getBackendErrorMessage" class="error-box"></div>
  </SimonModal>
</template>
<script>

import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import transaction from '@/mixins/transaction'
import beErrors from '@/mixins/beErrors'
import { mapActions, mapGetters } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'TariffOptionNotBookableModal',
  components: { SimonModal },
  data () {
    return {
      showModal: false,
      showDocument: false,
      errorMsg: false,
      gotBackendError: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('tariffOptions', [
      'confirmRevokeTariffoption'
    ]),
    initializeNotBookableOption () {
      if (this.initializeOptionStarted !== true) {
        this.showModal = true
        this.initializeOptionStarted = false
      }
    },
    trackOption (stepName) {
      const data = {
        page_levels: [
          'mein-simon',
          'uebersicht',
          'option cancellation withdrawal',
          stepName
        ],
        login_status: 'logged in',
        page_type: 'self service',
        platform_type: 'browser view',
        form: {
          name: 'withdraw cancel option',
          step: stepName === 'summary' ? '1' : '2',
          step_name: stepName,
          context: this.option.name + ' ' + this.formattedIncentive,
          type: 'ecare'
        }
      }
      if (stepName === 'confirmation') {
        data.form.status = 'success'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    },
    triggerErrorTracking () {
      const errMsg = this.getBackendErrorMessage
      if (errMsg !== null) {
        const data = {
          type: 'technical',
          message: errMsg.substring(0, 50),
          code: String(this.beErrorGetLastErrorCode())
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'accessToken'
    ]),
    getBackendErrorMessage: function () {
      if (this.errorMsg !== false) {
        return this.errorMsg
      }
      return this.beErrorGetLastMessage()
    },
    formattedPrice () {
      return this.formatDecimal(this.option.price / 100, 2) || '0,00'
    },
    formattedIncentive () {
      return this.option.volumes[0].amount + ' ' + this.option.volumes[0].formattedUnit
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    gotBackendErrorInitiate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [

    beErrors,
    price,
    formatDecimal,
    transaction('tariffOptions')
  ]
}
</script>
